import React, { Component } from 'react';

class Privacy extends Component {

    componentDidMount() {
        this.props.handleMenu(
            {
                title: 'Privacyverklaring',
                showBackButton: true,
            })
    }

    render() {

        return (
            <div className="padding">




                <br />
                <br />

                <b>Verzamelen en gebruiken van persoonsgegevens van klanten, leveranciers en andere opdrachtnemers </b><br />
                Graag maken wij u er op attent dat wij de persoonsgegevens die u ons verstrekt zullen verzamelen en gebruiken omdat dit noodzakelijk is om een eventuele overeenkomst met u te sluiten en uit te voeren. Dat geldt zowel voor onze (potentiële) klanten als voor partijen bij wie wij zaken en/of diensten inkopen.
<br />
                Bent u een (potentiële) klant van ons, dan gebruiken wij uw gegevens om u een offerte te kunnen toesturen, te kunnen bepalen aan welke specificaties of wensen een bepaalde zaak of dienst dient te voldoen, zaken te kunnen leveren of werkzaamheden voor u te kunnen verrichten, te kunnen factureren en met u vlot en efficiënt te kunnen communiceren over de uitvoeringsaspecten van de overeenkomst.
<br />

                Bent u een (potentiële) leverancier of andere opdrachtnemer dan zijn uw persoonsgegevens eveneens noodzakelijk voor de sluiting en uitvoering van de overeenkomst. Bij inkoop is dat nodig om u te kunnen laten weten aan welke specificaties of wensen een bepaalde zaak of dienst wat ons betreft dient te voldoen, een offerte-aanvraag te kunnen toesturen of een bestelling bij u te kunnen plaatsen, uw facturen te kunnen betalen en vlot en efficiënt met u te kunnen communiceren over andere aspecten van de overeenkomst.
<br />
                <br />

                U bent niet verplicht om ons uw persoonsgegevens te verstrekken. Als u ons geen of onvoldoende persoonsgegevens verstrekt, dan is het echter wel mogelijk dat wij aan de hiervoor genoemde werkzaamheden geen uitvoering kunnen geven.
<br />
                <br />

                <b>Doorgifte aan derden </b><br />
                In verband met de uitvoering van een eventuele overeenkomst met u is het mogelijk dat wij uw persoonsgegevens moeten verstrekken aan partijen die onderdelen, materialen en producten aan ons toeleveren of in onze opdracht werkzaamheden uitvoeren. Verder maken wij gebruik van externe serverruimte voor de opslag van (delen van) onze verkoop- en inkoopadministratie, waar uw persoonsgegevens een onderdeel van uitmaken. Uw persoonsgegevens worden om die reden aan onze provider van serverruimte verstrekt. Verder maken wij gebruik van Microsoft Office en de bijbehorende opslagmogelijkheden voor e-mails en andere bestanden. Omdat wij gebruik maken van een nieuwsbrief mailing dienst, worden uw persoonsgegevens tot slot doorgegeven aan de aanbieder van deze dienst.
<br />
                <br />

                <b>Bewaarperiode persoonsgegevens </b><br />
                Indien u een offerte bij ons heeft opgevraagd maar u geen klant bij ons geworden bent, zullen wij uw gegevens uiterlijk één jaar na ons laatste contact verwijderen. Ook indien wij een offerte van u hebben ontvangen, maar wij geen klant van u zijn geworden, zullen uw persoonsgegevens uiterlijk één jaar na ons laatste contact worden verwijderd. Bent u wel klant bij ons geworden of wij bij u, dan zullen wij uw persoonsgegevens bewaren voor de duur van zeven jaar na het einde van het boekjaar waarin de overeenkomst met u volledig is uitgevoerd. De periode van zeven jaar komt overeen met de periode waarbinnen wij verplicht zijn onze administratie te bewaren voor de Belastingdienst. Na afloop van deze periode zullen wij uw persoonsgegevens verwijderen.
<br />
                <br />

                <b>Uw rechten </b><br />
                U heeft het recht om ons te vragen om uw eigen persoonsgegevens te mogen inzien. Als daartoe aanleiding bestaat, kunt u ons ook verzoeken om aanvulling van uw persoonsgegevens of om het wijzigen van onjuistheden. Daarnaast heeft u het recht om te vragen om uw persoonsgegevens te wissen of het gebruik van uw persoonsgegevens te beperken. Ook kunt u bij ons bezwaar maken tegen het verzamelen en gebruiken van uw gegevens of een klacht indienen bij de Autoriteit Persoonsgegevens. Tot slot kunt u ons verzoeken om verkrijging van uw persoonsgegevens of overdracht van die gegevens aan een ander. Om uw rechten te kunnen uitoefenen kunt u zich wenden tot:
<br />

                <b>ARAL Lasservice BV, Gea Hagedoorn, Elzenweg 1/A, 8096 RK  OLDEBROEK  </b>
                (06)205 49732 gea@arallasservice.nl<br />

                Ook met vragen of voor meer informatie over het verzamelen en gebruiken van uw persoonsgegevens kunt u uiteraard contact met ons opnemen.  <br />
                <br />


                1 oktober 2018


            </div>
        );
    }
}

export default Privacy;
